import { useAccessLevel } from 'core/app/AppContext';

/**
 * Hook to check if the current user has SaleCycle access level
 * @returns true if user has SaleCycle access level, false otherwise
 */
export function useIsSaleCycleUser(): boolean {
  const { accessLevel } = useAccessLevel();
  return accessLevel === 'SaleCycle';
}
